import request from "../util/request";

export function notice() {
    return request({
        url: '/api-admin/user/admin/notice',
        method: 'get'
    })
}

/**
 * 新增用户
 * @param model
 * @returns {AxiosPromise}
 */
export function add(model) {
    return request({
        url: '/api-admin/user/admin/add',
        method: 'post',
        data: model
    })
}

/**
 * 修改用户
 * @param model
 * @returns {AxiosPromise}
 */
export function edit(model) {
    return request({
        url: '/api-admin/user/admin/edit',
        method: 'put',
        data: model
    })
}

export function del(userId) {
    return request({
        url: '/api-admin/user/admin',
        method: 'delete',
        params: {
            userId: userId
        }
    })
}

/**
 * 启用
 * @param userId
 * @returns {*}
 */
export function enable(userId) {
    return request({
        url: '/api-admin/user/admin/enable',
        method: 'put',
        params: {
            userId : userId
        }
    })
}

export function disable(userId) {
    return request({
        url: '/api-admin/user/admin/disable',
        method: 'put',
        params: {
            userId : userId
        }
    })
}

export function charge(model) {
    return request({
        url: '/api-admin/user/admin/balance',
        method: 'put',
        data: model
    })
}

export function resetPwd(model) {
    return request({
        url: '/api-admin/user/admin/reset/pwd/common',
        method: 'put',
        data: model
    })
}

export function resetPwdValidate(model) {
    return request({
        url: '/api-admin/user/admin/reset/pwd/validate',
        method: 'put',
        data: model
    })
}

export function page(model) {
    return request({
        url: '/api-admin/user/admin/page',
        method: 'post',
        data: model
    })
}
